<ng-container [ngSwitch]="tag()">
  <h1 *ngSwitchCase="'h1'" [ngClass]="getClass()" (click)="handleClick()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </h1>

  <h2 *ngSwitchCase="'h2'" [ngClass]="getClass()" (click)="handleClick()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </h2>

  <h3 *ngSwitchCase="'h3'" [ngClass]="getClass()" (click)="handleClick()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </h3>

  <p *ngSwitchCase="'p'" [ngClass]="getClass()" (click)="handleClick()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </p>

  <span *ngSwitchCase="'span'" [ngClass]="getClass()" (click)="handleClick()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </span>

  <label *ngSwitchCase="'label'" [ngClass]="getClass()" (click)="handleClick()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </label>

  <div *ngSwitchDefault [ngClass]="getClass()" (click)="handleClick()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </div>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
